"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputCounter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c5ee7e1bc{font-size:.875rem;font-weight:400;line-height:1.25rem;text-align:right;color:var(--color-flomni-gray-40)}");
var styles = {
  root: 'c5ee7e1bc'
};

var InputCounter = function InputCounter(props) {
  var maxLength = props.maxLength,
      currentLength = props.currentLength,
      classes = props.classes;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, currentLength, "/", maxLength);
};

exports.InputCounter = InputCounter;
InputCounter.propTypes = {
  /* component logic props */
  maxLength: _propTypes.node.isRequired,
  currentLength: _propTypes.node.isRequired,

  /* styling modificators */

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
InputCounter.defaultProps = {
  classes: {}
};